module.exports = __webpack_public_path__ + "img/call-chat.cf772dd.jpg";